module.exports = __webpack_public_path__ + "assets/images/pages/listarobinson/feature-2-icon-2.webp?53aa2891";